export interface LoginRequest {
  phone: string;
  code: string;
  route: string;
  grant_type: string;
  client_id: string;
  client_secret: string;
  machineVal: string;
  username: string;
}
export enum ACCESS {
  ZERO = 0,
  ONE,
}
export interface LoginRequestSwitch {
  route: string;
  grant_type: string;
  client_id: string;
  client_secret: string;
  companyId: string;
  phone: string;
  username: string;
  accessSystem: ACCESS;
}

export interface GetCodeRequest {
  phone: string;
  machineVal: string;
  clientType: "housekeeper";
  secret?: string | null;
}

/** 获取公司列表返回 */
export interface GetAgentUserIdResponse {
  companyid: string;
  companynumber: string;
  companyname: string;
  itemList?: any[];
}

export interface ExceedBudgetWarningRequest {
  agentId: string;
}
export interface ExceedBudgetWarningResponse {
  budgetCount: number;
  companyName: string;
  companyNumber: string;
}

export interface GetRoleAuthorityTreeResponse {
  parentid: number;
  name: string;
  rootid: number;
  islast: boolean;
  level: number;
  code: string;
  actionUrl: null | string;
  sort: number;
  isopen: null | boolean;
  smallType: number;
  childrenList: null | [];
  isSelect: boolean;
  id: number;
}

export interface GetAllSubCompanyListRequest {
  agentId: string;
  userId: string;
  phone: string;
}
export interface AgentLonginOem {
  Secret: string;
}
